import http from '../http'
import { IAnalyzeStatusDto, IRecalculationStatusDto, IReportDto } from './dtos'
import { mapAnalyzeStatusFromDto, mapRecalculationStatusFromDto, mapReportFromDto } from './helpers'
import { IAnalyzeResults } from './models'

const rootAPI = http.createClient(`${process.env.NEXT_PUBLIC_API_URL}`)
const analyzeAPI = http.createClient(`${process.env.NEXT_PUBLIC_API_URL}/analyze`)
const reportsAPI = http.createClient(`${process.env.NEXT_PUBLIC_API_URL}/reports`)

export const startAnalyze = async () => {
	const { data } = await analyzeAPI.post('')
	return data
}

export const getAnalyzeStatus = async () => {
	const { data } = await analyzeAPI.get<IAnalyzeStatusDto>('')
	return mapAnalyzeStatusFromDto(data)
}

export const getAnalyzeResults = async (taxYear: number) => {
	const { data } = await analyzeAPI.get<IAnalyzeResults>('/results', { params: { taxYear } })
	return data
}

export const getReports = async (taxYear: number) => {
	const { data } = await reportsAPI.get<IReportDto[]>('', { params: { taxYear } })
	return data.map(mapReportFromDto)
}

export const getReportBySlug = async (slug: string, taxYear: number) => {
	const { data } = await reportsAPI.get<IReportDto>(`/${slug}`, { params: { taxYear } })
	return mapReportFromDto(data)
}

export const requestReport = async ({ slug, taxYear }: { slug: string; taxYear: number }) => {
	const { data } = await reportsAPI.post(`/${slug}/request`, {
		taxYear,
	})
	return data
}

export const getRecalculations = async () => {
	const { data } = await rootAPI.get<IRecalculationStatusDto>('/recalculations')
	return mapRecalculationStatusFromDto(data)
}
